<h2 class="my-2 titletext">{{ title | titlecase }}</h2>

<div class="full-width-layout-content">
  <ng-content></ng-content>
</div>
